import {toList, toString} from "../helpers/helpers";
import {KeyByObject} from "../misc/reduce-helpers";

export class CDFValidationIssue {
  cdfId: string;
  itemNumber: string;
  floorMapId: string;
  productNumber: string;
  disposition: string;
  reasons: string[];
  reasonsMap: {[key: string]: boolean};

  constructor(row: any) {
    this.cdfId = toString(row.cdfId);
    this.itemNumber = toString(row.itemNumber);
    this.floorMapId = toString(row.floorMapId);
    this.productNumber = toString(row.productNumber);
    this.disposition = toString(row.disposition);
    this.reasons = toList(toString, row.reasons);
    this.reasonsMap = this.reasons.reduce((obj, k) => obj.add(k, true), new KeyByObject()).toObject();
  }
}

export class CDFValidationError extends Error {
  name = "CDFValidationError";
  issues: CDFValidationIssue[];

  static check(obj: any) {
    return obj && obj.name === "CDFValidationError" && Array.isArray(obj.issues);
  }

  constructor(obj: any) {
    super(obj.message || "An unexpected error occurred.");
    Object.setPrototypeOf(this, CDFValidationError.prototype);

    if (!CDFValidationError.check(obj)) {
      throw new Error("Not a CDFValidationError");
    }

    this.issues = toList(issue => new CDFValidationIssue(issue), obj.issues);
  }
}
